// extracted by mini-css-extract-plugin
export var additionalInfo = "projects-section-module--additionalInfo--AyrEu";
export var body = "projects-section-module--body--j07Pe";
export var card = "projects-section-module--card--vwkXR";
export var cardDescription = "projects-section-module--cardDescription--3k1K7";
export var cardImage = "projects-section-module--cardImage--V-AlC";
export var confidentialIcon = "projects-section-module--confidentialIcon--uLCD1";
export var dark = "projects-section-module--dark--7YMjx";
export var descriptionContainer = "projects-section-module--descriptionContainer--i7jPI";
export var heading = "projects-section-module--heading--4AjE6";
export var headingContainer = "projects-section-module--headingContainer--kB7Ng";
export var light = "projects-section-module--light--rvObQ";
export var orgLogo = "projects-section-module--orgLogo--toQDx";
export var projectCardsContainer = "projects-section-module--projectCardsContainer--PaCzW";
export var projectLinks = "projects-section-module--projectLinks--sEqZm";
export var projectsExpandContainer = "projects-section-module--projects-expand-container--2wtVp";
export var stack = "projects-section-module--stack--Lfztq";
export var stacksContainer = "projects-section-module--stacksContainer--FFVrB";